import React from "react";
import { NavLink } from "react-router-dom";
import "./profile.css";

const ProfileInfoComponent = () => {
  return (
    <div
      className="mt-15"
      style={{
        height: "calc(100vh - 50px)",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <div>
        <h3 className="mb-2 text-center">Configurações</h3>
        <p
          className="text-muted text-center mx-3"
          style={{ fontSize: "clamp(0.5rem, 0.8rem, 1rem)" }}
        >
          Selecione a atividade que está procurando...
        </p>
        <hr className="m-0" />
      </div>
      <div className="d-flex flex-wrap justify-content-center mt-3">
        {/* Botão Pagamento */}
        <div
          className="d-flex flex-column align-items-center m-4 card-container"
          style={{ flexBasis: "20%", maxWidth: "200px", minWidth: "150px" }}
        >
          <NavLink
            to="/subscriptions"
            className="btn btn-variant-profile w-100 shadow text-decoration-none"
          >
            <i className="fas fa-credit-card fa-2x mb-3" />
            <h6 className="card-title text-center mb-0">Pagamento</h6>
          </NavLink>

          <p className="card-description">
            Gerencie seus pagamentos com segurança.
          </p>
        </div>

        {/* Botão Planos
        <div
          className="d-flex flex-column align-items-center m-4 card-container"
          style={{ flexBasis: "20%", maxWidth: "200px", minWidth: "150px" }}
        >
          <NavLink
            to="/plans"
            className="btn btn-variant-profile w-100 shadow text-decoration-none"
          >
            <i className="fas fa-th-list fa-2x mb-3" />
            <h6 className="card-title text-center mb-0">Planos</h6>
          </NavLink>
          <p className="card-description">
            Veja e edite os planos de assinatura disponíveis.
          </p>
        </div>
         */}

        <div
          className="d-flex flex-column align-items-center m-4 card-container"
          style={{ flexBasis: "20%", maxWidth: "200px", minWidth: "150px" }}
        >
          <NavLink
            to="/logout"
            className="btn btn-variant-profile w-100 shadow text-decoration-none"
          >
            <i className="fas fa-sign-out-alt fa-2x mb-3" />
            <h6 className="card-title text-center mb-0">Encerrar Sessão</h6>
          </NavLink>
          <p className="card-description">
            Veja e edite os planos de assinatura disponíveis.
          </p>
        </div>

        {/* Botão Alterar Senha */}
        <div
          className="d-flex flex-column align-items-center m-4 card-container"
          style={{ flexBasis: "20%", maxWidth: "200px", minWidth: "150px" }}
        >
          <NavLink
            to="/"
            className="btn btn-variant-profile w-100 shadow text-decoration-none"
          >
            <i className="fas fa-lock fa-2x mb-3" />
            <h6 className="card-title text-center mb-0">Alterar senha</h6>
          </NavLink>
          <p className="card-description">
            Altere sua senha de acesso ao Vertex 4D.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfoComponent;
